import React, { useEffect, useRef, useState } from "react";
import { jakusci, left_arrow, no_image, pool, tub } from "../../assets/imgs";
import CancelIcon from "@mui/icons-material/Cancel";
import JoditEditor from "jodit-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAmenitiesListMutation, useLazyAmenitiesDropQuery, useLazyPropertiesRoomViewQuery, useLazyPropertyImageDeleteQuery, useLazyRoomCategoriesDropQuery, useMinimumAgeMutation, usePropertyRoomDetailsAddMutation } from "../../screens/redux/api/api";
import { toast } from "react-toastify";
import SelectBoxImg from "../../components/SelectBoxImg";
import { configJodit } from "../redux/api/Constants";

const PropertyRoomAdd = ({ setTabs, property_id }) => {
  const navigate = useNavigate();
  const editor = useRef(null);
  const [image, setImage] = useState("");
  const [popup, setPopup] = useState(false);
  const [roomCat, setRoomCat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amiList, setAmiList] = useState([]);
  const [validation, setValidation] = useState("");
  const [draggedItem, setDraggedItem] = useState(null);
  const location = useLocation();
  const prop_id = location?.state?.id;
  const room_id = location?.state?.room_id
  const type = location?.state?.type
  const cat_id = location?.state?.cat_id

  const catIds = location?.state?.catIds

  console.log('room_id', room_id)
  console.log('cat_id', cat_id, 'catIds', catIds)


  // RTK
  const [minimumAgeListApi] = useLazyRoomCategoriesDropQuery();
  const [aminitiesListApi] = useLazyAmenitiesDropQuery();
  const [roomsAddApi] = usePropertyRoomDetailsAddMutation();
  const [getRoomApi] = useLazyPropertiesRoomViewQuery()
  const [propertyImageDelete] = useLazyPropertyImageDeleteQuery()

  const [room, setRoom] = useState({
    room_category: "",
    no_of_room: "",
    amenities: [],
    price_per_day: {
      monday: "",
      tuesday: "",
      wednesday: "",
      thursday: "",
      friday: "",
      saturday: "",
      sunday: "",
    },
    total_person_count: "",
    extra_person_count: "",
    extra_charges_per_person: "",
    description: "",
    images: [],
    imageId: [],
  });

  // Drag and drop handlers
  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.currentTarget);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;

    setRoom(prev => {
      const newImages = [...prev.images];
      const [removed] = newImages.splice(draggedItem, 1);
      newImages.splice(index, 0, removed);

      return {
        ...prev,
        images: newImages
      };
    });

    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const addRoomsFunc = async () => {
  setLoading(true);
  try {
    const formData = new FormData();
    formData.append('property_id', prop_id.toString());
    
    if (room_id) {
      formData.append('room_id', room_id.toString());
    }

    // Room details
    formData.append('rooms[0][room_category_id]', room.room_category.toString());
    formData.append('rooms[0][no_of_rooms]', room.no_of_room.toString());

    // Amenities
    room.amenities.forEach((amenity, index) => {
      formData.append(`rooms[0][amenity_ids][${index}]`, amenity.id.toString());
    });

    // Prices
    formData.append('rooms[0][prices][mon_price]', (room.price_per_day.monday || "0").toString());
    formData.append('rooms[0][prices][tue_price]', (room.price_per_day.tuesday || "0").toString());
    formData.append('rooms[0][prices][wed_price]', (room.price_per_day.wednesday || "0").toString());
    formData.append('rooms[0][prices][thu_price]', (room.price_per_day.thursday || "0").toString());
    formData.append('rooms[0][prices][fri_price]', (room.price_per_day.friday || "0").toString());
    formData.append('rooms[0][prices][sat_price]', (room.price_per_day.saturday || "0").toString());
    formData.append('rooms[0][prices][sun_price]', (room.price_per_day.sunday || "0").toString());
    formData.append('rooms[0][prices][total_persons]', (room.total_person_count || "0").toString());
    formData.append('rooms[0][prices][additional_persons]', (room.extra_person_count || "0").toString());
    formData.append('rooms[0][prices][extra_charge_per_person]', (room.extra_charges_per_person || "0").toString());

    // Description
    formData.append('rooms[0][description]', room.description);

    // Process images - both new and existing
    for (const [imageIndex, image] of room.images.entries()) {
      try {
        if (image instanceof File) {
          // Newly uploaded file
          formData.append(
            `rooms[0][property_images][${imageIndex}][position]`,
            (imageIndex + 1).toString()
          );
          formData.append(
            `rooms[0][property_images][${imageIndex}][image]`,
            image,
            image.name || `image_${imageIndex}`
          );
        } else if (typeof image === 'string') {
          let blob;
          if (image.startsWith('data:')) {
            // Base64 image
            blob = base64ToBlob(image);
          } else {
            // URL image
            const response = await fetch(image);
            if (!response.ok) throw new Error(`Failed to fetch image from ${image}`);
            blob = await response.blob();
          }
          
          formData.append(
            `rooms[0][property_images][${imageIndex}][position]`,
            (imageIndex + 1).toString()
          );
          formData.append(
            `rooms[0][property_images][${imageIndex}][image]`,
            blob,
            `image_${imageIndex}`
          );
        }
      } catch (error) {
        console.error(`Error processing image ${imageIndex}:`, error);
        // Continue with other images even if one fails
      }
    }

    // Call the API
    const res = await roomsAddApi(formData).unwrap();
    toast.success(res?.message || (type === 'edit' ? "Room updated successfully!" : "Room added successfully!"));
    navigate(-1);
  } catch (err) {
    console.error('API Error:', err);
    toast.error(err?.data?.message || (type === 'edit' ? "Failed to update room" : "Failed to add room"));
  } finally {
    setLoading(false);
  }
};

// Helper function to convert base64 to Blob
const base64ToBlob = (base64) => {
  const byteString = atob(base64.split(',')[1]);
  const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};


  const handleImageDelete = (id) => {
    propertyImageDelete(id)
      .unwrap()
      .then((res) => {
        if (res?.status == 'success') {
          toast.success(res?.message)
        }
      }).catch((err) => {
        toast.error(err?.message)
      })
  }


  const getAgeList = (type) => {
    minimumAgeListApi()
      .unwrap()
      .then((res) => {

        console.log('res', res);

        let temx = []

        if (Array.isArray(catIds)) {
          temx = [...catIds]
        }

        console.log('temx', temx);


        if (location?.state?.type == 'edit') {
          let tempz = temx?.filter((i) => i != cat_id)
          console.log('tempz', tempz);

          let temp = res?.data?.filter(item => !tempz.includes(item?.id))
          setRoomCat(temp);
          console.log('tempEdit', temp);
        } else {

          let temp = res?.data.filter(item => !temx.includes(item?.id));
          setRoomCat(temp)

          console.log('tempAdd', temp);


        }



      }).catch((err) => {
        console.log('err', err);
      });
  };

  const getAminitiesList = () => {
    let formdata = new FormData();
    formdata.append('pagination', 0);
    aminitiesListApi(formdata)
      .unwrap()
      .then((res) => {
        setAmiList(res?.data);
      }).catch((err) => {
        console.error('err-ami', err);
      });
  };

  const getRoom = (id) => {
    getRoomApi(id)
      .unwrap()
      .then((res) => {
        const roomData = res.data;

        // Map the API response to our room state
        setRoom({
          room_category: roomData.room_category_id,
          no_of_room: roomData.no_of_rooms,
          amenities: roomData.amenities.map(amenity => ({
            id: amenity.amenity_id,
            name: amenity.amenity?.name || '',
            image_url: amenity.image_url
          })),
          price_per_day: {
            monday: roomData.prices?.mon_price,
            tuesday: roomData.prices?.tue_price,
            wednesday: roomData.prices?.wed_price,
            thursday: roomData.prices?.thu_price,
            friday: roomData.prices?.fri_price,
            saturday: roomData.prices?.sat_price,
            sunday: roomData.prices?.sun_price
          },
          total_person_count: roomData.prices?.total_persons,
          extra_person_count: roomData.prices?.additional_persons,
          extra_charges_per_person: roomData.prices?.extra_charge_per_person,
          description: roomData.description,
          images: roomData.images.map(img => img.image_url), // This will need adjustment for file objects
          imageId: roomData.images.map(img => img.id),
        });

        // Set the editor content if it exists
        if (editor.current) {
          editor.current.value = roomData.description;
        }
      }).catch((err) => {
        console.log('err_room_details', err);
      });
  };

  console.log(room.price_per_day, 'prices')

  useEffect(() => {
    getAgeList(1);
    getAminitiesList();
    if (room_id) {
      getRoom(room_id)
    }
  }, []);

  const showImgPopup = (item) => {
    setImage(item);
    setPopup(true);
  };

  const handleChange = (value, field, subField) => {
    if (subField) {
      setRoom(prev => ({
        ...prev,
        price_per_day: {
          ...prev.price_per_day,
          [subField]: value
        }
      }));
    } else if (field === "images") {
      // Handle file uploads
      const files = value.target.files;
      if (files) {
        const filesArray = Array.from(files);
        if (room.images.length + filesArray.length > 10) {
          toast.error("You can only upload a maximum of 10 images.");
          return;
        }
        setRoom(prev => ({
          ...prev,
          images: [...prev.images, ...filesArray]
        }));
      }
    } else {
      setRoom(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };

  const removeAmenity = (index) => {
    setRoom(prev => {
      const newAmenities = [...prev.amenities];
      newAmenities.splice(index, 1);
      return {
        ...prev,
        amenities: newAmenities
      };
    });
  };

  const removeImage = (index, item) => {
    const imgId = item?.[index];
    console.log('imgId', imgId);
    handleImageDelete(imgId)
    setRoom(prev => {
      const newImages = [...prev.images];
      newImages.splice(index, 1);
      return {
        ...prev,
        images: newImages
      };
    });
  };

  const imgRef = useRef(null);

  return (
    <div className="dashRightView home_section" >
      <div className="mt-2">
        <div className="d-flex ac-js">
          <div className="d-flex ac-js pointer gap-2">
            <img
              src={left_arrow}
              className="leftArrow mb-3 pointer"
              onClick={() => navigate(-1)}
            />
            <p
              className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
              onClick={() => navigate(-1)}
            >
              Back
            </p>
          </div>
        </div>

        <div className="d-flex gap-5 mb-4">
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              Room Category
            </h4>
            <select
              className="input-pop ps-2 w-100"
              value={room?.room_category}
              onChange={(e) => handleChange(e.target.value, "room_category")}
            >
              <option value={""}>Select</option>
              {roomCat?.map((item) => (
                <option key={item?.id} value={item?.id}>
                  {item?.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-5">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
              No of Rooms
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="No of Rooms"
              value={room?.no_of_room}
              onChange={(e) => handleChange(e.target.value, "no_of_room")}
            />
          </div>
        </div>

        <div className="col-md-12">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
            Amenities
          </h4>
          <div className="col-md-5">
            <SelectBoxImg
              array_list={amiList}
              value_text={room?.amenities}
              setvalue_text={(value) => handleChange(value, "amenities")}
              setValidation={setValidation}
              isMulti={true}
              isTextArea={false}
            />
          </div>
          <div className="d-flex align-items-center flex-wrap gap-4 mt-4">
            {room?.amenities?.map((amenity, index) => (
              <div
                className="d-flex ac-jc gap-1 p-2 input-pop mb-3 position-relative"
                key={index}
              >
                <img
                  src={amenity?.image_url || tub}
                  className="tub-img"
                  alt={amenity?.name}
                />
                <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                  {amenity?.name}
                </p>
                <div onClick={() => removeAmenity(index)}>
                  <CancelIcon
                    className="red pointer"
                    style={{
                      position: "absolute",
                      top: "-7px",
                      right: "-7px",
                      width: "15px",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-4">
          Pricing Per Day
        </h4>
        <div className="input-pop_box">
          <table className="w-100">
            <thead>
              <tr className="text-center">
                <th>Monday</th>
                <th>Tuesday</th>
                <th>Wednesday</th>
                <th>Thursday</th>
                <th>Friday</th>
                <th>Saturday</th>
                <th>Sunday</th>
              </tr>
            </thead>
            <tbody>
              <tr className="text-center">
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.monday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "monday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.tuesday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "tuesday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.wednesday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "wednesday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.thursday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "thursday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.friday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "friday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    p type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.saturday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "saturday")}
                  />
                </td>
                <td className="col-md-1">
                  <input
                    className="input-pop w-80 mt-2 mb-2 text-center"
                    type="text"
                    placeholder='Enter Amount'
                    maxLength={5}
                    minLength={0}
                    value={room?.price_per_day?.sunday}
                    onChange={(e) => handleChange(e.target.value, "price_per_day", "sunday")}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="d-flex flex-wrap ac-jb my-5">
          <div className="col-md-3">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Total Person Count
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Total Person Count"
              value={room?.total_person_count}
              onChange={(e) => handleChange(e.target.value, "total_person_count")}
            />
          </div>
          <div className="col-md-3">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Extra Person Count
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Extra Person Count"
              value={room?.extra_person_count}
              onChange={(e) => handleChange(e.target.value, "extra_person_count")}
            />
          </div>
          <div className="col-md-3">
            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
              Extra Charges Per Person
            </h4>
            <input
              type="text"
              className="input-pop ps-2 w-100"
              placeholder="Extra Charges Per Person"
              value={room?.extra_charges_per_person}
              onChange={(e) => handleChange(e.target.value, "extra_charges_per_person")}
            />
          </div>
        </div>

        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
          Description
        </h4>
        <JoditEditor
          style={{ border: "1px solid #0C3A2D" }}
          className="input-pop w-100"
          config={configJodit}
          ref={editor}
          value={room?.description}
          onBlur={(newContent) => handleChange(newContent, "description")}
        />

        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 mt-3">
          Choose Images (Max 10)
        </h4>
        <div className="d-flex ac-js gap-3 flex-wrap">
          <div className="position-relative">
            <button
              className="cust-btn recep-yes mt-3 mb-3"
              onClick={() => imgRef.current?.click()}
            >
              Upload
            </button>
            <input
              type="file"
              className="input-pop mt-2 w-100 d-none"
              accept="image/*"
              onChange={(e) => handleChange(e, "images")}
              multiple={true}
              ref={imgRef}
              disabled={room.images.length >= 10}
            />
            <div className="d-flex flex-wrap gap-2 mt-2">
              {room?.images?.map((itemImg, index) => (
                <div
                  key={index}
                  className="position-relative"
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={(e) => handleDragOver(e, index)}
                  onDragEnd={handleDragEnd}
                  style={{
                    opacity: draggedItem === index ? 0.5 : 1,
                    cursor: 'move'
                  }}
                // onMouseDown={type === 'edit' ? false : true}
                >
                  <img
                    src={itemImg?.name ? URL.createObjectURL(itemImg) : itemImg}
                    style={{
                      height: "100px",
                      width: "100px",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => showImgPopup(itemImg)}
                    alt=""
                  />
                  <CancelIcon
                    className="red pointer"
                    style={{
                      position: "absolute",
                      top: "-5px",
                      right: "-7px",
                      width: "20px",
                    }}
                    onClick={() => removeImage(index, room?.imageId)}
                  />
                </div>
              ))}
            </div>
          </div>



          {popup && (
            <div className="img-popup-design">
              <div className="img-popup">
                <div className='d-flex ac-je pointer' onClick={() => {
                  setPopup(false);
                  setImage("");
                }}>
                  <CancelIcon />
                </div>
                <div
                  style={{
                    width: "350px",
                    height: "350px",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "8px",
                    marginTop: "1rem",
                    backgroundColor: "#f8f8f8"
                  }}
                >
                  <img
                    src={image?.name ? URL.createObjectURL(image) : image}
                    alt="Selected"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain"
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex ac-je mt-5">
          <button
            className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
            onClick={addRoomsFunc}
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm"></div>
            ) : (
              type === 'edit' ? "Update" : "Submit"
            )}
          </button>
        </div>

      </div>
    </div>
  );
};

export default PropertyRoomAdd;